import { getJitsiMeetGlobalNS } from "../util/helpers";

getJitsiMeetGlobalNS();
declare let JitsiMeetJS: any;
export default JitsiMeetJS;
